<template>
  <div class="control_bar top">
    <img :src="helpIcon" height="25px" />
    {{ title }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      helpIcon: require('../../img/notifications2.png'),
      title: 'お知らせ'
    }
  }
}
</script>
<style scoped>
.control_bar {
  width: 100%;
  height: 55px;
  background-color: #00ada7;
  text-align: left;
  color: #fff;
}
.control_bar img {
  vertical-align: -75%;
  margin: 12px 8px 12px 14px;
  width: 22px;
  height: auto;
}
.control_bar img:after {
  padding-top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/controllbar.vue